import {
    GET_TOOLBOX_LIST,
    GET_NEW_TOOLBOX_UID,
    SET_TOOLBOX,
    GET_TOOLBOXTYPE_LIST,
    SET_FILTER_TOOL_TYPE,
    SET_ROW_COUNT,
    SET_PAGE_INDEX,
    SET_SORT_TABLE_TYPE,
    SET_SORT_TABLE_AS,
    SET_SORT_TABLE_KEY,
} from "./types";

const INITIAL_STATE = {
    requesting: false,
    posting: false,
    allToolBoxList: false,
    toolboxType: false,
    rowCount: 50,
    pageIndex: 0,
    sortTableType: "asc",
    sortTableKey: false,
    sortTableAs: false,
    toolType: "all_categories",
    newID: "",
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_TOOLBOX_LIST.REQUEST: {
            return { ...state, requesting: true, allToolBoxList: false };
        }
        case GET_TOOLBOX_LIST.FAIL: {
            return { ...state, requesting: false, allToolBoxList: false };
        }
        case GET_TOOLBOX_LIST.SUCCESS: {
            return {
                ...state,
                requesting: false,
                allToolBoxList: action.payload,
            };
        }
        case GET_NEW_TOOLBOX_UID.REQUEST: {
            return { ...state, requesting: true, newID: false };
        }
        case GET_NEW_TOOLBOX_UID.FAIL: {
            return { ...state, requesting: false, newID: false };
        }
        case SET_ROW_COUNT: {
            return { ...state, rowCount: action.payload };
        }
        case SET_PAGE_INDEX: {
            return { ...state, pageIndex: action.payload };
        }

        case SET_SORT_TABLE_TYPE: {
            return { ...state, sortTableType: action.payload };
        }
        case SET_SORT_TABLE_KEY: {
            return { ...state, sortTableKey: action.payload };
        }

        case SET_SORT_TABLE_AS: {
            return { ...state, sortTableAs: action.payload };
        }
        case GET_NEW_TOOLBOX_UID.SUCCESS: {
            return {
                ...state,
                requesting: false,
                newID: action.payload,
            };
        }
        case SET_TOOLBOX.REQUEST: {
            return { ...state, requesting: true, posting: true };
        }
        case SET_TOOLBOX.FAIL: {
            return { ...state, requesting: false, posting: false };
        }
        case SET_TOOLBOX.SUCCESS: {
            return { ...state, requesting: false, posting: false };
        }
        case GET_TOOLBOXTYPE_LIST.REQUEST: {
            return { ...state, requesting: true, toolboxType: false };
        }
        case GET_TOOLBOXTYPE_LIST.FAIL: {
            return { ...state, requesting: false, toolboxType: false };
        }
        case GET_TOOLBOXTYPE_LIST.SUCCESS: {
            return {
                ...state,
                requesting: false,
                toolboxType: action.payload,
            };
        }
        case SET_FILTER_TOOL_TYPE: {
            return { ...state, toolType: action.payload };
        }
        default: {
            return state;
        }
    }
};
